
import * as defaultImport from "@splunk/react-ui/Scroll";
export * from "@splunk/react-ui/Scroll";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
